import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

export default class MutationWithOverlay extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };

  mutate = (mutate, mutationResult) => {
    const { children } = this.props;
    const { client } = mutationResult;

    return children(async (...args) => {
      client.writeData({
        data: {
          showLoadingOverlay: true,
        },
      });

      try {
        await mutate(...args);
      } finally {
        client.writeData({
          data: {
            showLoadingOverlay: false,
          },
        });
      }
    }, mutationResult);
  };

  render() {
    return <Mutation {...this.props}>{this.mutate}</Mutation>;
  }
}



// WEBPACK FOOTER //
// ./src/components/MutationWithOverlay/index.js